import { FC } from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { LEAD_TIMES } from 'src/constants';

const LeadTimeCell: FC<React.PropsWithChildren<GridCellProps>> = ({ dataItem, field }) => {

  let leadTime: number;

  if (field && dataItem[field] != null && typeof dataItem[field] === 'number' && dataItem[field] >= 1) {
    leadTime = dataItem[field] + LEAD_TIMES.ADDITIONAL_LEAD_TIME_DAYS;
  } else {
    leadTime = LEAD_TIMES.DEFAULT_LEAD_TIME_DAYS;
  }

  return (
    <td>
      {leadTime}
    </td>
  );
};

export default LeadTimeCell;
